"use client";

import { useEffect, useState } from "react";
import { Package, Database, Users, Building2 } from "lucide-react";

export default function StatusBar({ stats = {} }) {
  const [time, setTime] = useState("");

  useEffect(() => {
    const update = () => {
      const now = new Date();
      setTime(
        now.toLocaleTimeString("es", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
    };
    update();
    const i = setInterval(update, 1000);
    return () => clearInterval(i);
  }, []);

  const {
    departments = 6,
    users = 7,
    orders = 0,
  } = stats;

  return (
    <div className="statusbar-aero h-7 px-4 flex items-center justify-between text-[11px] text-aero-text-muted font-medium select-none z-50">
      {/* Left: brand */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1.5">
          <Package className="w-3 h-3 text-aero-blue-bright" />
          <span className="font-semibold text-aero-text tracking-wide">
            Bolpack OS
          </span>
          <span className="text-aero-text-dim">v1.0</span>
        </div>
        <span className="text-aero-text-dim">·</span>
        <div className="flex items-center gap-1.5">
          <Database className="w-3 h-3 text-aero-success" />
          <span>PostgreSQL conectado</span>
        </div>
      </div>

      {/* Center: stats */}
      <div className="hidden md:flex items-center gap-5">
        <div className="flex items-center gap-1.5">
          <Building2 className="w-3 h-3" />
          <span>
            <span className="text-aero-text font-semibold">{departments}</span> deptos
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          <Users className="w-3 h-3" />
          <span>
            <span className="text-aero-text font-semibold">{users}</span> usuarios
          </span>
        </div>
        {orders > 0 && (
          <>
            <span className="text-aero-text-dim">·</span>
            <span>
              <span className="text-aero-text font-semibold">{orders}</span> órdenes activas
            </span>
          </>
        )}
      </div>

      {/* Right: status + time */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1.5">
          <span className="status-dot" />
          <span className="text-aero-success tracking-wide font-semibold">
            EN LÍNEA
          </span>
        </div>
        <span className="font-mono text-aero-text-dim tabular-nums">
          {time}
        </span>
      </div>
    </div>
  );
}
